<template>
  <v-list-group v-model="open">
    <template #activator>
      <v-list-item-action class="my-1">
        <h-badged-avatar
          icon="container"
          :resource="item"
        />
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title v-text="item.name" />
      </v-list-item-content>
    </template>
    <template v-for="(linkedItem, i) in linkedItems(item.id)">
      <h-item-formatted
        v-if="linkedItem.type == MenuItemType.SELLING_FORMAT"
        :key="`li${i}`"
        :item="linkedItem"
        :disabled="disabled"
        sub-group
        class="ml-4"
      />
      <h-item-regular
        v-else
        :key="`li${i}`"
        :item="linkedItem"
        :disabled="disabled"
        dense
        class="pl-8"
      />
    </template>
  </v-list-group>
</template>

<script>
  import { mapGetters } from 'vuex'
  import MenuItemType from '@/Models/Static/MenuItemType'
  import HBadgedAvatar from '@/Components/BadgedAvatar'
  import HItemFormatted from './ItemFormatted'
  import HItemRegular from './ItemRegular'

  export default {
    components: {
      HBadgedAvatar,
      HItemFormatted,
      HItemRegular,
    },

    props: {
      item: {
        required: true,
        type: Object,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      MenuItemType,
      open: false,
    }),

    computed: {
      ...mapGetters('catalog', [
        'linkedItems',
      ]),
    },

    watch: {
      open (v) {
        if (v) {
          this.$emit('unfold')
        }
      },
    },
  }
</script>
